const packageObj = require('../../package.json');
const version = packageObj.version;

export const environment = {
  production: false,
  security: {
    type: 'oauth2',
    configFile: 'assets/config/config-app.json?version=' + version
  },
  header: {
    img: 'assets/images/Logo_Autostrade-new.png',
    imgBottom: 'assets/images/logo-bottom-movyon.png',
    title: 'SSM',
    viewSwitchTheme: false
  },
  footer: {
    year: 'v. ' + version + ' 2021',
    title: 'Powered by Movyon',
    link: 'https://www.movyon.com/'
  }
};
